import { render, staticRenderFns } from "./TablaRegistro.vue?vue&type=template&id=7b786e99&scoped=true&"
import script from "./TablaRegistro.vue?vue&type=script&lang=js&"
export * from "./TablaRegistro.vue?vue&type=script&lang=js&"
import style0 from "./TablaRegistro.vue?vue&type=style&index=0&id=7b786e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b786e99",
  null
  
)

export default component.exports